"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactRedux = require("react-redux");

var _creators = require("../../../redux/creators");

var _utils = require("./../../../configuration/utils");

var _ProductOverviewComponent = _interopRequireDefault(require("../../PEP-hearing-instrument-list/js/components/product-list/ProductOverviewComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getParameterByName = function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

var RelatedProducts = function RelatedProducts() {
  var productId = parseInt(getParameterByName("productId"), 10);
  var dispatch = (0, _reactRedux.useDispatch)();
  var relatedProducts = (0, _reactRedux.useSelector)(function (state) {
    return state.relatedProducts;
  });
  var selectedProduct = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });

  var sortRelatedProduct = function sortRelatedProduct(products) {
    var relatedProducts = products.filter(function (device) {
      return device.productFamily === selectedProduct.productFamily && device.productId !== productId;
    });
    dispatch((0, _creators.setRelatedProducts)(relatedProducts));
  };

  (0, _react.useEffect)(function () {
    if (!relatedProducts && selectedProduct) {
      (0, _utils.getProductListWithSettings)(dictionary.settingsParam.params, dictionary.settingsParam.token).then(function (pimData) {
        sortRelatedProduct(pimData.hearingAids);
      })["catch"](function (err) {
        console.error(err);
      });
    }

    var test = document.querySelector(".related-products__slider .slick-slider .slick-list .slick-track");
    setTimeout(function () {
      if (relatedProducts) {
        if (relatedProducts.length === 1) {
          test.style.width = "unset";
        }
      }
    }, 0);
  }, [relatedProducts, selectedProduct]);
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _creators.setRelatedProducts)(null));
    };
  }, []);
  var relatedSlider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [{
      breakpoint: 1000,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        arrows: false,
        lazyLoad: "ondemand",
        dots: true
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, relatedProducts && relatedProducts.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "related-products-section flex-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details grid-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "related-products"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, dictionary.relatedProducts, " (", relatedProducts.length, ")"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "related-products__slider"
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], relatedSlider, relatedProducts.map(function (product, index) {
    return /*#__PURE__*/_react["default"].createElement(_ProductOverviewComponent["default"], {
      product: product,
      index: index,
      key: product.productId,
      dictionary: dictionary,
      isAccessoriesList: false,
      lazyLoad: false,
      isMobile: null,
      isRouter: false
    });
  })))))));
};

var _default = RelatedProducts;
exports["default"] = _default;